//@flow
import React from 'react';

import type { FidBadgeType } from 'types/Fid';

import './fidBadgeCard.css';

type Props = {
  badge: FidBadgeType
};

function FidBadgeCard({ badge }: Props) {
  return (
    <div className={`fid-badge-card level-${badge.level}`}>
      <div className="fid-badge-card__button mb-1">
        <img src={badge.logo} />
        <h4 className="degrade_fid">{badge.title}</h4>
      </div>
    </div>
  );
}

export default FidBadgeCard;
